export const translationStatistics_sv_part5 = {
  authTokenNotFound: "Autentiseringstoken hittades inte.",
  errorFetchingUsers: "Fel vid hämtning av användare",
  errorFetchingUserIndexes: "Fel vid hämtning av användarens kunskapsbasindex",
  noTextContentFound: "Inget textinnehåll hittades i PDF",
  errorExtractingPdfText: "Fel vid extrahering av text från PDF. Försök igen.",
  selectAccessibleUser: "Välj tillgänglig användare",
  selectAccessibleUserPlaceholder: "Välj tillgänglig användare",
  selectUser: "Välj användare",
  selectUserToManage: "Välj användare att hantera",
  selectUserToManagePlaceholder: "Välj användare att hantera",
  noMatchingResults: "Inga matchande resultat hittades",
  noDataFoundForUser: "Inga data hittades för {username}",
  noDataFound: "Inga data hittades",
  textChunkingWarningTitle: "Texten kräver uppdelning",
  textChunkingWarningMessage:
    "Din text är {chars} tecken lång och överskrider gränsen på 25 000 tecken. Du har två alternativ:",
  textChunkingAutoOption: "Automatisk uppdelning",
  textChunkingAutoDescription:
    "Systemet delar automatiskt upp din text i {chunks} meningsfulla delar med 10 % överlappning.",
  textChunkingManualOption: "Manuell uppdelning",
  textChunkingManualDescription: "Gå tillbaka och dela upp texten i mindre avsnitt själv.",
  textChunkingProceed: "Dela upp automatiskt",
  textChunkingGoBack: "Gå tillbaka",
  textChunkingInProgress: "Delar upp text...",
  textChunkUploadNote: "Varje del laddas upp som en separat, sökbar post",
  createFolder: "Skapa mapp",
  createNewFolder: "Skapa ny mapp",
  folderName: "Mappnamn",
  enterFolderName: "Ange mappnamn",
  parentFolder: "Överordnad mapp",
  selectParentFolder: "Välj överordnad mapp",
  rootNoFolder: "Rot (ingen mapp)",
  uploadToFolder: "Ladda upp till mapp",
  selectFolder: "Välj mapp",
  folderNameRequired: "Mappnamn krävs",
  folderCreatedSuccessfully: "Mapp skapad",
  errorCreatingFolder: "Fel vid skapande av mapp",
  creatingFolder: "Skapar...",
  uploadToThisFolder: "Ladda upp till den här mappen",
  entryMovedToFolder: "Post flyttad till mapp",
  entryMovedToRoot: "Post flyttad till rot",
  errorMovingEntryToFolder: "Det gick inte att flytta posten till mappen",
  dragToMove: "Dra för att flytta",
  noIndexesAvailable: "Inga kunskapsbaser tillgängliga",
  numberOfChunks: "Antal delar",
  renameFolder: "Byt namn på mapp",
  renameFolderButton: "Byt namn",
  renamingFolder: "Byter namn...",
  folderRenamedSuccessfully: "Mapp omdöpt",
  errorRenamingFolder: "Det gick inte att byta namn på mappen",
  changesSavedSuccessfully: "Ändringar sparade",
};
